import { composeModule } from '../composeActions';

import pkg from '../package.json';

export const {
  composeStateMachine,
  composeEffects,
  composeMiddleware,
  composeSubscriber,
  exportModule,
  namespace
} = composeModule(`${pkg.name}/core`, pkg.version);
